import { Injectable } from '@angular/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Properties } from 'posthog-js';
import { ObjectAssociationType, ObjectType } from '../tokens-and-interfaces';
import { GalaxyFilterInterface, GalaxyFilterOperator, GalaxyFilterType } from '@vendasta/galaxy/filter/chips';

@Injectable()
export class CRMTrackingService {
  private eventName = 'crm';

  constructor(private readonly trackingService: ProductAnalyticsService) {}

  trackEvent(objectType: ObjectType | ObjectAssociationType | string, action: string, properties?: Properties): void {
    this.trackingService.trackEvent(
      this.eventName,
      `${this.eventName}-${objectType?.toLowerCase()}`,
      action,
      0,
      properties,
    );
  }

  trackFilterUsage(objectType: ObjectType | ObjectAssociationType, filters: GalaxyFilterInterface[]): void {
    for (const filter of filters) {
      // only track filters that had explicit values specified for them, presets will only count if explicitly set or are empty/not empty from the start
      const valueLength = filter.values?.length || 0;
      if (
        valueLength === 0 &&
        ![GalaxyFilterOperator.FILTER_OPERATOR_IS_EMPTY, GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY].includes(
          filter.operator,
        )
      ) {
        continue;
      }
      if (!filter?.fieldId) {
        continue;
      }
      // override filters and filters within the activity context don't have a filter type right now
      const filterType = filter.definition?.type ? GalaxyFilterType[filter.definition?.type] : 'FILTER_TYPE_UNKNOWN';
      this.trackEvent(objectType, 'selected-crm-filter', {
        filterType: filterType,
        filterOperator: GalaxyFilterOperator[filter.operator || GalaxyFilterOperator.FILTER_OPERATOR_INVALID],
        fieldId: filter.fieldId,
        filterId: filter.filterId,
        isPreset: filter.definition?.preset || false,
        // override filters always come without a name
        fieldName: filter.definition?.fieldName || 'Unknown',
      });
    }
  }
}
